import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const countryOptions = [
  { code: "+91", label: "(IN)" },
  { code: "+1", label: "(US)" },
  { code: "+971", label: " (AE)" },
];

const MobileLogin = () => {
  const navigate = useNavigate();
  const [countryCode, setCountryCode] = useState(countryOptions[0].code);
  const [mobileNumber, setMobileNumber] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    // Placeholder submit handler routes to OTP verification with masked number.
    const maskedNumber =
      mobileNumber.trim().length >= 4
        ? `${countryCode} XXXX XXXX${mobileNumber.trim().slice(-2)}`
        : `${countryCode} XXXXXXXX`;
    navigate("/login/mobile/verify", {
      state: { phone: maskedNumber },
    });
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center px-4 py-12 bg-primary overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 -right-10 h-72 w-72 bg-white/10 blur-[140px]"></div>
        <div className="absolute -bottom-20 -left-10 h-80 w-80 bg-accent/20 blur-[150px]"></div>
        <div className="absolute inset-x-0 top-1/3 h-px bg-white/10"></div>
      </div>
      <div className="relative w-full max-w-3xl">
        <div className="relative bg-white/95 rounded-[32px] p-8 md:p-10 shadow-[0_35px_120px_rgba(15,23,42,0.55)] border border-white/40 overflow-hidden">
          <div className="absolute inset-y-0 right-0 w-1/2 bg-gradient-to-b from-primary-light/5 via-transparent to-primary/10 blur-3xl pointer-events-none"></div>
          <button
            type="button"
            onClick={() => navigate("/login")}
            className="inline-flex items-center gap-2 text-sm font-semibold text-indigo-600 hover:text-indigo-800 transition"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 19l-7-7 7-7"
              />
            </svg>
            Back to sign-in options
          </button>

          <div className="mt-6 space-y-2">
            <p className="text-xs font-semibold uppercase tracking-[0.35em] text-slate-400">
              Secure access
            </p>
            <h1 className="text-3xl md:text-4xl font-black text-slate-900">
              What's your number?
            </h1>
            <p className="text-base text-slate-500">
              We'll send a one-time password to verify your account and keep
              your study sessions secure.
            </p>
          </div>

          <form className="mt-8 space-y-8" onSubmit={handleSubmit}>
            <div className="space-y-2">
              <label className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
                Mobile number
              </label>
              <div className="flex flex-wrap items-center gap-3 rounded-2xl border border-slate-200 bg-white px-4 py-3 shadow-sm focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-100">
                <div className="w-full sm:w-[15%] min-w-[120px]">
                  <select
                    value={countryCode}
                    onChange={(event) => setCountryCode(event.target.value)}
                    className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-2 text-sm font-semibold text-slate-700 focus:outline-none focus:ring-2 focus:ring-indigo-200"
                  >
                    {countryOptions.map((option) => (
                      <option key={option.code} value={option.code}>
                        {option.code} {option.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="h-px w-full bg-slate-200 sm:h-8 sm:w-px sm:bg-slate-200"></div>
                <input
                  type="tel"
                  value={mobileNumber}
                  onChange={(event) => setMobileNumber(event.target.value)}
                  placeholder={`${countryCode} 98765 43210`}
                  className="flex-1 min-w-[200px] bg-transparent text-lg font-semibold tracking-widest text-slate-900 focus:outline-none"
                  required
                />
              </div>
            </div>

            <button
              type="submit"
              className="w-full rounded-md bg-primary py-3.5 text-white text-lg font-semibold shadow-lg shadow-primary/30 hover:brightness-105 transition disabled:opacity-70"
              disabled={!mobileNumber.trim()}
            >
              Send OTP
            </button>

            <p className="text-xs text-center text-slate-500">
              By continuing, you agree to our{" "}
              <span className="font-semibold text-indigo-600 hover:text-indigo-700 cursor-pointer">
                Terms of Service
              </span>{" "}
              &{" "}
              <span className="font-semibold text-indigo-600 hover:text-indigo-700 cursor-pointer">
                Privacy Policy
              </span>
              .
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default MobileLogin;
